import { defineNuxtPlugin } from '#app';
import { ElDrawer } from 'element-plus';
import 'element-plus/es/components/drawer/style/css';

export default defineNuxtPlugin((nuxtApp) => {
  if (ElDrawer.name) {
    nuxtApp.vueApp.component(ElDrawer.name, ElDrawer);
  }
});
